<template>
  <v-footer color="transparent">
    <v-row align="end" no-gutters>
      <v-col cols="12" md="8">
        <div>v0.1.5</div>
        <div>COPYRIGHT © {{ new Date() | moment("YYYY") }} <span class="primary--text">{{ $store.state.appSettings.company.shortName }}</span>, All rights Reserved</div>
      </v-col>
      <v-col cols="12" md="4" class="text-right">
        <!-- <div>
          <v-btn
            v-for="link in links"
            :key="link.link"
            color="primary"
            text
            :href="link.link"
            class="text-capitalize ml-1 font-weight-regular"
          >
            {{ link.text }}
          </v-btn>
        </div> -->
        <v-btn
          v-for="icon in icons"
          :key="icon.icon"
          :href="icon.link"
          class="mr-1"
          icon
        >
          <v-icon size="24px">{{ icon.icon }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>

export default {
  name: 'Footer',

  data: () => ({
    icons: [
      {icon: 'mdi-facebook', link: 'https://newwavelending.com'},
      {icon: 'mdi-twitter', link: 'https://newwavelending.com'},
      {icon: 'mdi-github', link: 'https://newwavelending.com'},

    ],
    links: [
      {text: 'About Us', link: 'https://newwavelending.com/about-us'},
      {text: 'Blog', link: 'https://newwavelending.com'},
    ]
  }),
}
</script>

<style src="@/styles/Footer.scss" lang="scss"/>

